const $inject = ['$q', 'dataService', 'pointsOfInterestService', '$timeout', '$rootScope', '$scope'];

const lbaPointsOfInterestCtrl = function ($q, dataService, pointsOfInterestService, $timeout, $rootScope, $scope) {
  let vm = this;
  let debtorsEndpoint = 'Debtors';
  let pointsOfInterestEndpoint = 'PointOfInterests';

  vm.detailActive = false;

  vm.refreshDebtors = refreshDebtors;
  vm.getPointsOfInterest = getPointsOfInterest;
  vm.toggleDetail = toggleDetail;
  vm.editItem = editItem;
  vm.newItem = newItem;
  vm.saveItem = saveItem;
  vm.deleteItem = deleteItem;
  vm.activateItem = activateItem;
  vm.toggleItemActive = toggleItemActive;
  vm.activeItem = {};

  function activateItem(item){
    $rootScope.$emit('leaflet.highlight', item);
    toggleItemActive(item);
  }

  function toggleItemActive(item, digest){
    vm.activeItem.active = false;
    vm.activeItem = item;

    if(digest){
      $scope.$apply(function(){
        item.active = true;
      });
    } else {
        item.active = true;
    }
  }

  function toggleDetail() {
    vm.detailActive = !vm.detailActive;
  }

  function editItem(item){ // toggle form
    vm.activePointOfInterest = item;
    vm.detailActive = true;
  }

  function newItem(){ // toggle form
    vm.activePointOfInterest = null;
    vm.detailActive = true;
  }

  function saveItem(item){
    let deferred = $q.defer();
    pointsOfInterestService.savePointOfInterest(vm.debtor.Name, item)
      .then((success)=>{
        getPointsOfInterest(function(){
          deferred.resolve(success);
          $timeout(function(){
            $rootScope.$emit('leaflet.refresh', vm.refreshMap);
          });
        })      
      })
      .catch(data =>{
        deferred.reject(data);
      });;
    return deferred.promise;
  }


  function deleteItem(itemId){
    let deferred = $q.defer();
    pointsOfInterestService.deletePointOfInterest({ id: itemId })
      .then((data)=>{
        getPointsOfInterest(function(){
          deferred.resolve(data);
          $timeout(function(){
            $rootScope.$emit('leaflet.refresh', vm.refreshMap);
          });
        });

      })
      .catch(data =>{
        deferred.reject(data);
      });
    return deferred.promise;
  }


  function getPointsOfInterest(cb){
    loadMap();
    let optionalParameters = {
      includeDeleted: false,
    };
    dataService.search(pointsOfInterestEndpoint, vm.debtor.Name, 'DebtorIdentifier', null, optionalParameters).then(result => {
      vm.pointsOfInterest = result;

      $timeout(function(){
        $rootScope.$emit('leaflet.refresh', vm.refreshMap);
      });

      if(typeof cb !== 'undefined'){
        cb();
      }
    });
  }

  function loadMap(){
    vm.showMap = true;
  }

  function refreshDebtors(selected){
    dataService.search(debtorsEndpoint, selected, 'Name', 'contains').then(result => {
      vm.debtors = result;
    });
  }

};

lbaPointsOfInterestCtrl.$inject = $inject;

export default lbaPointsOfInterestCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterest/lbaPointsOfInterestCtrl.js